module.exports = __webpack_public_path__ + "static/media/hot-storage-big.b5930a51.png";